import React from "react";
import Navbar from "../components/common/navbar";
import MyWishlist from "../components/account/myWishlist";
import Footer from "../components/common/footer";
import MobileSidebarLink from "../components/account/mobileSidebarLink";

const WishlistPage = () => {
  return (
    <div>
      <Navbar />
      <div className="md:mx-16 flex">
        <div className="hidden md:block">
          <MobileSidebarLink />
        </div>
        <MyWishlist />
      </div>
      <Footer/>
    </div>
  );
};

export default WishlistPage;
